(function () {
  function setPanelState(item, open) {
    const trigger = item.querySelector('[data-mfs-trigger]');
    const panel = item.querySelector('.media-feature-stack__content');
    item.classList.toggle('is-open', open);
    if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (panel) panel.setAttribute('aria-hidden', open ? 'false' : 'true');
  }

  function pauseVideo(video) {
    if (!video) return;
    try {
      video.pause();
      if (!Number.isNaN(video.currentTime)) video.currentTime = 0;
    } catch (e) {}
  }

  function playVideo(video, frame) {
    if (!video) return;
    const shouldAutoplay = !frame || frame.dataset.mfsAutoplay !== 'false';
    if (!shouldAutoplay) return;
    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {});
    }
  }

  function syncEmbed(frame, active) {
    if (!frame || !frame.hasAttribute('data-mfs-embed')) return;
    const src = frame.dataset.mfsEmbedSrc || '';
    let iframe = frame.querySelector('iframe.media-feature-stack__iframe');

    if (!active) {
      if (iframe) iframe.remove();
      return;
    }

    if (!src) return;
    if (!iframe) {
      iframe = document.createElement('iframe');
      iframe.className = 'media-feature-stack__iframe';
      iframe.title = 'Feature video';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.loading = 'lazy';
      frame.appendChild(iframe);
    }
    if (iframe.getAttribute('src') !== src) {
      iframe.setAttribute('src', src);
    }
  }

  function syncSlideMedia(slides, activeIndex) {
    slides.forEach((slide, i) => {
      const active = i === activeIndex;
      const frame = slide.querySelector('.media-feature-stack__media-frame');
      const video = slide.querySelector('video');

      if (active) {
        playVideo(video, frame);
        syncEmbed(frame, true);
      } else {
        pauseVideo(video);
        syncEmbed(frame, false);
      }
    });
  }

  function setActiveIndex(root, index) {
    const items = Array.from(root.querySelectorAll('.media-feature-stack__item'));
    const slides = Array.from(root.querySelectorAll('[data-mfs-slide]'));
    if (!items.length) return;

    const safeIndex = Math.min(Math.max(0, index), items.length - 1);

    items.forEach((item, i) => {
      setPanelState(item, i === safeIndex);
    });

    slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === safeIndex);
      slide.setAttribute('aria-hidden', i === safeIndex ? 'false' : 'true');
    });

    syncSlideMedia(slides, safeIndex);
    root.dataset.mfsActiveIndex = String(safeIndex);
  }

  function initDesktop(root) {
    const items = Array.from(root.querySelectorAll('.media-feature-stack__item'));
    if (!items.length) return;

    const initial = Number(root.dataset.mfsInitialIndex || '0');
    setActiveIndex(root, Number.isNaN(initial) ? 0 : initial);

    items.forEach((item, index) => {
      const trigger = item.querySelector('[data-mfs-trigger]');
      if (!trigger) return;

      trigger.addEventListener('click', () => {
        setActiveIndex(root, index);
      });
    });
  }

  function getScrollStep(container) {
    const item = container.querySelector('.media-feature-stack__mobile-card');
    if (!item) return 0;
    const styles = window.getComputedStyle(container);
    const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
    return item.offsetWidth + gap;
  }

  function getActiveIndex(container) {
    const step = getScrollStep(container);
    if (step <= 0) return 0;
    return Math.round(container.scrollLeft / step);
  }

  function updateMobileProgress(container, progress) {
    const segments = progress.querySelectorAll('.media-feature-stack__mobile-progress-segment');
    if (!segments.length) return;
    const activeIndex = getActiveIndex(container);
    segments.forEach((segment, index) => {
      segment.classList.toggle('is-active', index === activeIndex);
    });
    return activeIndex;
  }

  function syncMobileVideos(container, activeIndex) {
    const cards = Array.from(container.querySelectorAll('.media-feature-stack__mobile-card'));
    cards.forEach((card, i) => {
      const frame = card.querySelector('.media-feature-stack__media-frame');
      const video = card.querySelector('video');
      if (i === activeIndex) {
        playVideo(video, frame);
      } else {
        pauseVideo(video);
      }
    });
  }

  function initMobileCarousel(root) {
    const container = root.querySelector('[data-mfs-mobile-scroll]');
    const progress = root.querySelector('[data-mfs-mobile-progress]');
    if (!container) return;

    const segments = progress
      ? progress.querySelectorAll('.media-feature-stack__mobile-progress-segment')
      : [];

    const scrollToIndex = (index) => {
      const step = getScrollStep(container);
      if (step <= 0) return;
      const maxScroll = Math.max(0, container.scrollWidth - container.clientWidth);
      const next = Math.min(Math.max(0, index * step), maxScroll);
      container.scrollTo({ left: next, behavior: 'smooth' });
    };

    const onScroll = () => {
      const activeIndex = progress
        ? updateMobileProgress(container, progress)
        : getActiveIndex(container);
      syncMobileVideos(container, activeIndex);
    };

    container.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    segments.forEach((segment) => {
      segment.addEventListener('click', () => {
        const index = Number(segment.dataset.slideIndex);
        if (Number.isNaN(index)) return;
        scrollToIndex(index);
      });
    });

    onScroll();
  }

  function initRoot(root) {
    initDesktop(root);
    initMobileCarousel(root);
  }

  function boot() {
    document.querySelectorAll('[data-mfs]').forEach(initRoot);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-mfs]');
    if (root) initRoot(root);
  });
})();
